import { ref } from 'vue'

const partnerName = ref(null)

const PARTNERS = ['pinapples']

export default {
  install: app => {
    const partnerService = {
      name: partnerName,
      setPartner: name => {
        console.log('[PartnerPlugin] Parceiros válidos:', PARTNERS)

        if (!PARTNERS.includes(name)) {
          console.warn(`[PartnerPlugin] Parceiro não encontrado: "${name}"`)
          return
        }

        partnerName.value = name
        sessionStorage.setItem('partner_name', name)

        loadCustomCSS(name)
      }
    }

    app.config.globalProperties.$partner = partnerService
    app.provide('partner', partnerService)

    app.mixin({
      created() {
        if (this.$root !== this) return
        const partnerName = sessionStorage.getItem('partner_name')
        console.log(partnerName)

        if (partnerName && PARTNERS.includes(partnerName)) {
          console.log('Setting partner from URL detection', partnerName)
          this.$partner.setPartner(partnerName)
          return
        }
      }
    })
  }
}

function loadCustomCSS(partnerName, retryCount = 0) {
  if (!partnerName) {
    console.warn('[PartnerPlugin] Nenhum nome de parceiro fornecido para carregar CSS')
    return
  }

  const maxRetries = 3
  const retryDelay = 500
  const existingCSS = document.getElementById('partner-custom-css')

  if (existingCSS) {
    existingCSS.remove()
  }

  const cssUrl = `/styles/partners/${partnerName}.css?v=${Date.now()}`

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.id = 'partner-custom-css'
  link.href = cssUrl

  link.onload = () => {
    link.onloadFired = true
  }

  link.onerror = error => {
    console.error(`[PartnerPlugin] Falha ao carregar CSS para ${partnerName}:`, error)
    if (retryCount < maxRetries) {
      const nextRetry = retryCount + 1
      const delay = retryDelay * nextRetry
      console.log(`[PartnerPlugin] Tentando novamente em ${delay}ms (${nextRetry}/${maxRetries})...`)
      setTimeout(() => {
        loadCustomCSS(partnerName, nextRetry)
      }, delay)
    } else {
      console.error(
        `[PartnerPlugin] Número máximo de tentativas (${maxRetries}) atingido. Não foi possível carregar o CSS para ${partnerName}`
      )
    }
  }

  const timeoutId = setTimeout(() => {
    if (!link.sheet && !link.onloadFired) {
      link.onerror(new Error('CSS load timeout'))
    }
  }, 5000)

  link.onload = () => {
    clearTimeout(timeoutId)
    console.log(`[PartnerPlugin] CSS carregado com sucesso: ${partnerName}.css`)
    console.log('[PartnerPlugin] CSS aplicado?', !!link.sheet)
    link.onloadFired = true
  }

  document.head.appendChild(link)
}
